exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a[data-v-a1a987da]{text-decoration:none}.blue-color[data-v-a1a987da]{color:#589df8}.el-tag[data-v-a1a987da]{font-weight:400}", "", {"version":3,"sources":["/workspace/src/views/task/pages/ReviewTaskTable.vue"],"names":[],"mappings":"AACA,mBAAmB,oBAAoB,CACtC,AACD,6BAA6B,aAAa,CACzC,AACD,yBAAyB,eAAkB,CAC1C","file":"ReviewTaskTable.vue","sourcesContent":["\na[data-v-a1a987da]{text-decoration:none\n}\n.blue-color[data-v-a1a987da]{color:#589df8\n}\n.el-tag[data-v-a1a987da]{font-weight:normal\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1a987da","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/task/pages/ReviewTaskTable.vue
// module id = 5552
// module chunks = 277